import {
    createContext,
    useContext,
    useCallback,
    useEffect,
    useState,
} from 'react';
import { notification } from 'antd';
import { useAuth } from '../Auth';
import useAPI from '../../hooks/integrations/useAPI';
import { API_BASE_URL } from '../../settings/constants';

const Context = createContext();

const Provider = ({ children }) => {
    const api = useAPI();
    const auth = useAuth();

    const [version, setVersion] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const getVersion = useCallback(() => {
        setIsLoading(true);
        const url = `${API_BASE_URL}/version`;
        console.info('V1.API_GET : ', url.toString());
        return api
            .makeRequest({ url, method: 'GET' })
            .then(({ data }) => {
                setVersion(data);
                notification.close('customerError');
                setIsLoading(false);
            })
            .catch((err) => {
                notification.close('customerError');
                setTimeout(
                    () =>
                        notification.error({
                            key: 'customerError',
                            //description: <ErrorNotification key={Date.now()} />,
                            duration: null,
                        }),
                    100
                );

                setIsLoading(false);
            });
    }, [auth.user]);

    useEffect(() => {
        if (auth.user) {
            getVersion();
        }
    }, [auth.user]);

    return (
        <Context.Provider
            value={{
                version,
                isLoading,
            }}
        >
            {children}
        </Context.Provider>
    );
};

export const useVersionCtx = () => {
    return useContext(Context);
};

export default Provider;
